import {CreatePolicy, InsurePolicy, InsurerId, SortBy, UpdateDocument} from '../../Config/dataModel';
import {
    fetchAllPolicies,
    fetchPolicyCount,
    insurerApplyPY,
    insurerInsurePY,
    updatePolicy
} from '../Actions/policyAction';

export default (dispatch) => {
    return {
        fetchAllPolicies: (data: SortBy) => {
            dispatch(fetchAllPolicies(data));
        },
        fetchPolicyCount: (data: InsurerId) => {
            dispatch(fetchPolicyCount(data));
        },
        insurerApplyPY: (data: CreatePolicy) => {
            dispatch(insurerApplyPY(data));
        },
        insurerInsurePY: (ref: string, data: InsurePolicy) => {
            dispatch(insurerInsurePY(ref, data));
        },
        updatePolicy: (ref: string, data: UpdateDocument) => {
            dispatch(updatePolicy(ref, data));
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/policyDispatch.ts